const DASHBOARD = 'Dashboard';
const CREATE = 'Create';
const INSIGHTS = 'Insights';
const PAYOUT_INFORMATION = 'Payout Information';
const USER_MANAGEMENT = 'User Management';

const showCreateRoles = ['creator', 'editor'];

export function hasAccessToCreateApp(legacyPermissions = [], permissions) {
  if (permissions) {
    return permissions.some(permission => permission.app === 'create');
  }

  return legacyPermissions.some(
    ({ resource, role }) => resource === 'Channel' && showCreateRoles.includes(role)
  );
}

export function hasAccessToInsightsApp(legacyPermissions = [], permissions) {
  if (permissions) {
    return permissions.some(permission => permission.app === 'insights');
  }

  return legacyPermissions.some(({ resource }) => resource === 'Channel');
}

export function hasAccessToFinanceApp(roles = []) {
  return roles.some(role => role === 'finance');
}

export function hasAccessToUserManagementApp(permissions) {
  if (permissions) {
    return permissions.some(permission => permission.app === 'rolesApi');
  }

  return false;
}

export function hasAccessTo(label, legacyPermissions, legacyRoles, permissions) {
  switch (label) {
    case DASHBOARD:
      return true;
    case CREATE:
      return hasAccessToCreateApp(legacyPermissions, permissions);
    case INSIGHTS:
      return hasAccessToInsightsApp(legacyPermissions, permissions);
    case PAYOUT_INFORMATION:
      return hasAccessToFinanceApp(legacyRoles);
    case USER_MANAGEMENT:
      return hasAccessToUserManagementApp(permissions);
    default:
      return false;
  }
}

export function generateUrl(label, href, isAuth0, token, encodedSession) {
  // Always send encodedSession when linking to Payout Information (It needs to save it)
  if (href === '/' || (isAuth0 && label !== PAYOUT_INFORMATION)) return href;

  switch (label) {
    case DASHBOARD:
      return `${href}/${encodedSession}`;
    case CREATE:
    case INSIGHTS:
    case USER_MANAGEMENT:
      return `${href}/sign/${encodedSession}`;
    case PAYOUT_INFORMATION:
      return `${href}/sign?encoded_session=${encodedSession}`;
    default:
      return href;
  }
}
